import { connectCustom } from "@client/lib/misc";

import { makeHeadingPropsSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { makeTextStyleSelector, TargetSelector } from "@client/selectors";
import { type BaseAppState } from "@client/types";
import { localStateSelector } from "../../selectors";
import Component, { type BlogDetailPostTitleProps } from "./component";

const makeMapStateToProps = () => {
  const postInfoStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "postInfo");
  const titleHeadingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity, "title");

  return (state: BaseAppState, props: RootContainerProps): BlogDetailPostTitleProps => {
    const localState = localStateSelector(state, props);
    return {
      post: localState.post!,
      headingProps: titleHeadingPropsSelector(state, props),
      postInfoStyle: postInfoStyleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
